import { Stack } from '@mui/material';
import type { ThresholdBundleFormController } from './threshold-bundle-form.hook';
import { ThresholdAssignmentStep } from './ThresholdAssignmentStep';
import { ThresholdConfirmationStep } from './ThresholdConfirmationStep';
import { ThresholdDefinitionStep } from './ThresholdDefinitionStep';
import { ThresholdStyleStep } from './ThresholdStyleStep';

// -- type definitions --

export interface ThresholdBundleFormContentProps {
  controller: ThresholdBundleFormController;
}

// -- main component --

export function ThresholdBundleFormContent({
  controller,
}: ThresholdBundleFormContentProps) {
  return (
    <Stack spacing={3}>
      {controller.activeStep === 0 && (
        <ThresholdDefinitionStep controller={controller} />
      )}
      {controller.activeStep === 1 && (
        <ThresholdAssignmentStep controller={controller} />
      )}
      {controller.activeStep === 2 && (
        <ThresholdStyleStep controller={controller} />
      )}
      {controller.activeStep === 3 && (
        <ThresholdConfirmationStep controller={controller} />
      )}
    </Stack>
  );
}
